import axios from "axios";

export function updateXtcs(params) {
  return axios({
    url: "/api/updateXtcs",
    method: "post",
    data: params,
  });
}

export function addXtcs(params) {
  return axios({
    url: "/api/addXtcs",
    method: "post",
    data: params,
  });
}

export function delXtcs(params) {
  return axios({
    url: "/api/delXtcs",
    method: "post",
    data: params,
  });
}

export function editQueryArea(params) {
  return axios({
    url: "/api/xtglYmpz/editQueryArea",
    method: "post",
    data: params,
  });
}

export function editTableArea(params) {
  return axios({
    url: "/api/xtglYmpz/editTableArea",
    method: "post",
    data: params,
  });
}

export function getQueryAreaConfig(params) {
  return axios({
    url: "/api/xtglYmpz/getQueryAreaConfig",
    method: "post",
    data: params,
  });
}

export function getTableAreaConfig(params) {
  return axios({
    url: "/api/xtglYmpz/getTableAreaConfig",
    method: "post",
    data: params,
  });
}

export function getYmszTree(param) {
  return axios({
    url: "/api/getYmszTree",
    method: "post",
    data: param,
  });
}

export function getCzrzList(param) {
  return axios({
    url: "/api/xtglCzrz/getCzrzList",
    method: "post",
    data: param,
  });
}

export function getDlrzList(param) {
  return axios({
    url: "/api/xtglDlrz/getDlrzList",
    method: "post",
    data: param,
  });
}

export function addXtgl(param) {
  return axios({
    url: "/api/xtglGggl/addXtgl",
    method: "post",
    data: param,
  });
}

export function updateXtgl(param) {
  return axios({
    url: "/api/xtglGggl/updateXtgl",
    method: "post",
    data: param,
  });
}

export function delXtgl(param) {
  return axios({
    url: "/api/xtglGggl/delXtgl",
    method: "post",
    data: param,
  });
}

export function getXtgxs() {
  return axios({
    url: "/api/xtglXtgx/getxtgxs",
    method: "get",
  });
}

export function addXtgx2(param) {
  return axios({
    url: "/api/xtglXtgx/addxtgx2",
    method: "post",
    data: param,
  });
}

export function updateXtgx(param) {
  return axios({
    url: "/api/xtglXtgx/updatextgx",
    method: "post",
    data: param,
  });
}

export function delXtgx(param) {
  return axios({
    url: "/api/xtglXtgx/delxtgx",
    method: "post",
    data: param,
  });
}

export function updateXt() {
  return axios({
    url: "/api/xtglXtgx/updatext",
    method: "get",
  });
}

